import { useDefaultMetric } from '@plato/app-shared/hooks/use-default-metric';
import { usePersistedQueryParams } from '@plato/app-shared/hooks/use-persisted-query-params';
import { customerListParamsConfig, type CustomerListParams } from '@plato/app-shared/utils/customer-list';
import type { SetValue } from '@plato/ui-legacy/lib/hooks/use-query-params';
import { useMemo } from 'react';

export type CustomerListParamsState = {
    params: CustomerListParams;
    setParams: SetValue<CustomerListParams>;
    defaultParams: CustomerListParams;
};

export function useCustomerListParams(): CustomerListParamsState {
    const defaultMetric = useDefaultMetric();
    const defaultParams = useMemo<CustomerListParams>(
        () => ({
            sorting: {
                by: { salesMetric: { field: 'total_amount', dimension: defaultMetric } },
                direction: 'desc',
            },
        }),
        [defaultMetric],
    );
    const [params, setParams] = usePersistedQueryParams(
        customerListParamsConfig,
        defaultParams,
        'customer-list-v2',
    );

    return { params, setParams, defaultParams };
}
